/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import './style.scoped.scss';
import {
  FaRegWindowClose,
  FaSearch,
  FaSearchengin,
  FaSortAmountDown,
  FaSortAmountUpAlt,
} from 'react-icons/fa';
import AdvancedSearch from '../AdvancedSearch';
import DocumentResults from '../DocumentResults';
import Loader from '../Loader';
import { DocSortColumns, ROUTES } from '../../assets/constants/strings';
import { Link } from 'react-router-dom';
import {
  clearDocSearch,
  clearSearch,
  setCurrentDocument,
} from '../../store/Document/documentActions';
import TabIndexBtn from '../Buttons/TabIndex';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';

const SearchResult = ({
  searchKeyword,
  docSearchLoading,
  pageSearchLoading,
  searchResults,
  documentResults,
  documents,
  isAdvanced,
  handleClose,
  handleTagSelected,
  isSearchPage,
  setCurrentDocument,
  clearDocSearch,
  clearSearch,
  handleSearch,
}) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [displayAdvanced, setDisplayAdvanced] = useState(isAdvanced);

  const [selectedSort, setSelectedSort] = useState('title');
  const [selectedOrder, setSelectedOrder] = useState('>');

  const [selectedTab, setSelectedTab] = useState(2);

  const [displayResults, setDisplayResults] = useState(null);

  // array to store enhanced search results
  const [refinedPagesResult, setRefinedPagesResult] = useState(null);

  const [searchValue, setSearchValue] = useState('');
  const [activeCard, setActiveCard] = useState('');
  const [onlyShowTitles, setOnlyShowTitles] = useState(false);
  const [docSearchTitles, setDocSearchTitles] = useState(null);
  const [docSearchPages, setDocSearchPages] = useState(null);

  useEffect(() => {
    if (searchKeyword) setSearchValue(searchKeyword);
  }, [searchKeyword]);

  useEffect(() => {
    return () => {
      if (!isSearchPage) {
        clearSearch();
        clearDocSearch();
      }
    };
  }, []);

  const CurrentDocs = () => {
    const documentIDsFromPages = []; // empty arr

    searchResults?.forEach((page) => {
      // if document is not already there, push it
      if (!documentIDsFromPages.some((doc) => doc === page.documentId))
        documentIDsFromPages.push(page.documentId);
    });

    const documentsFound = [];

    documentIDsFromPages.forEach((id) => {
      if (documents.filter((doc) => doc.id === id)[0])
        documentsFound.push(documents.filter((doc) => doc.id === id)[0]);
    });

    documentResults?.forEach((doc) => {
      if (!documentsFound.some((item) => item.id === doc.id)) {
        documentsFound.push(doc);
      }
    });

    // logic to add wanted parameters for sorting
    documentsFound.forEach((doc) => {
      doc.results = getPagesFromDocument(doc.id).length;
    });

    // Filter unique documents by id
    const uniqueDocuments = Array.from(
      new Map(documentsFound.map((doc) => [doc.id, doc])).values()
    );

    return uniqueDocuments;
  };

  useEffect(() => {
    if (searchResults) {
      setRefinedPagesResult(CurrentDocs());
    } else setDisplayResults([]);

    // docs loaded and pages are loading or empty
    if (documentResults && documentResults.length > 0) {
      setDocSearchTitles(documentResults);
      // setSelectedTab(1);
    } else setDisplayResults([]);

    // pages loaded and documents are loading or empty
    if (
      (searchResults && searchResults.length > 0) ||
      (documentResults && documentResults.length > 0)
    ) {
      setDocSearchPages(CurrentDocs());
      // setSelectedTab(2);
    } else setDisplayResults([]);

    // if both loaded
    // else if (searchResults && documentResults) {
    //   // if the initial selected tab has no results and the other has, show that one
    //   if (selectedTab === 1 && documentResults.length === 0) setSelectedTab(2);
    //   if (selectedTab === 2 && searchResults.length === 0) setSelectedTab(1);
    // }
  }, [searchResults, documentResults]);

  useEffect(() => {
    // setDisplayResults(refinedPagesResult);

    // number of results column does not exist in document, so if user is there, change sort to title
    if (selectedTab === 1 && selectedSort === 'results')
      setSelectedSort('title');
  }, [selectedTab, refinedPagesResult]);

  useEffect(() => {
    if (onlyShowTitles) {
      if (docSearchTitles?.length > 0) {
        setDisplayResults(docSearchTitles);
        setSelectedTab(1);
      } else {
        setDisplayResults([]);
        setSelectedTab(1);
      }
    } else {
      setDisplayResults(docSearchPages);
      setSelectedTab(2);
    }
    setSelectedPage(1);
  }, [onlyShowTitles, docSearchTitles, docSearchPages]);

  const isMobile = window.innerWidth < 415;
  $('[data-toggle="tooltip"]').tooltip();

  // useEffect(() => {
  //   setSelectedPage(1);
  // }, [displayResults]);

  const handleCloseSearch = () => {
    handleClose();
  };

  const getPagesFromDocument = (id) => {
    return searchResults
      ? searchResults.filter((page) => page.documentId === id)
      : [];
  };

  const handleSelectedTag = (tag) => {
    handleTagSelected(tag, false);
  };

  const toggleAdvSearchVisible = () => {
    const currentBool = displayAdvanced;
    setDisplayAdvanced(!currentBool);

    if (displayAdvanced) setOnlyShowTitles(false);
  };

  const handleSort = (value) => {
    // if (selectedSort === value) handleOrder();
    setSelectedSort(value);
  };

  const handleOrder = () => {
    const currOrder = selectedOrder;
    currOrder === '>' ? setSelectedOrder('<') : setSelectedOrder('>');
  };

  const handleDisplayOrderBtn = (column) => {
    return selectedSort === column ? (
      selectedOrder === '<' ? (
        <p
          className='ml-2 sort-button sort-button__order'
          onClick={handleOrder}
        >
          Desc. <FaSortAmountDown className='ml-2 mr-0' />
        </p>
      ) : (
        <p
          className='ml-2 sort-button sort-button__order'
          onClick={handleOrder}
        >
          Asc. <FaSortAmountUpAlt className='ml-2 mr-0' />
        </p>
      )
    ) : null;
  };

  const pageCount = displayResults
    ? Math.ceil(displayResults.length / itemsPerPage)
    : 1;
  const indexOfLastItem = selectedPage * itemsPerPage;
  const indexOfFirstTodo = indexOfLastItem - itemsPerPage;

  const orderedDocs = displayResults
    ? selectedOrder === '>'
      ? displayResults
          .sort((a, b) =>
            typeof a[selectedSort] === 'string'
              ? a[selectedSort].localeCompare(b[selectedSort], undefined, {
                  numeric: true,
                })
              : a[selectedSort] > b[selectedSort]
              ? 1
              : -1
          )
          .slice(indexOfFirstTodo, indexOfLastItem)
      : displayResults
          .sort((a, b) =>
            typeof a[selectedSort] === 'string'
              ? b[selectedSort].localeCompare(a[selectedSort], undefined, {
                  numeric: true,
                })
              : a[selectedSort] < b[selectedSort]
              ? 1
              : -1
          )
          .slice(indexOfFirstTodo, indexOfLastItem)
    : [];

  const handlePaginationClick = (selectedItem) => {
    setSelectedPage(selectedItem.selected + 1);
  };

  const handleToggleCard = (doc) => {
    if (doc.id !== activeCard) setActiveCard(doc.id);
    else setActiveCard('');

    // logic to prevent multiple sticky tops at once if user clicks on another one
    $('.card.sticky-top').each((_i, e) => {
      if (e.id !== `card-${doc.id}`) {
        e.className = 'card';
      }
    });

    const thisCard = document.getElementById(`card-${doc.id}`);
    const thisCollapse = document.getElementById(`collapse-${doc.id}`);

    // logic to add sticky top effect to selected card
    if (thisCard && thisCollapse && thisCard.className === 'card') {
      // spacing is different according to rightnav
      const rightNavVisible =
        document.getElementById('menu-outer-wrapper') === null;

      // if main content height is auto, calculation is different
      const scrollableMain = window.outerHeight > 721;

      thisCard.className = `card sticky-top${
        rightNavVisible ? '' : ' right-collapsed'
      }`;
      thisCollapse.style.maxHeight = scrollableMain
        ? `${
            document.getElementById('main-content').clientHeight -
            (rightNavVisible ? 120 : 190)
          }px`
        : `${
            document.getElementById('wf-scroll-wrapper').clientHeight -
            (rightNavVisible ? 50 : 100)
          }px`;

      // scroll down to element
      // setTimeout(() => {
      //   $(`#main-content`).scrollTop($(`#card-${doc.id}`).offset().top);
      // }, 200);
    } else if (thisCard) {
      thisCard.className = 'card';
    }
  };

  const defineTitle = (doc) =>
    `${doc.levelOne.Title} / ${doc.levelTwo.Title}${
      doc.levelThree ? ' / ' + doc.levelThree.Title : ''
    }${doc.levelFour ? ' / ' + doc.levelFour.Title : ''}`;

  const replaceTitle = (text) => {
    // Split the searchKeyword into words and escape special characters
    const words = searchValue
      .split(/\s+/)
      .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); // Escape special characters

    // Create a regex to match any of the words
    const regex = new RegExp(`(${words.join('|')})`, 'gi');

    // Highlight each matched word
    return text.replace(regex, '<mark>$1</mark>');
  };

  const handleInput = (e) => {
    handleSearch(e);
  };

  return (
    <div className='col main-content-wrapper search-results'>
      {displayAdvanced ? (
        <AdvancedSearch
          initialKeyword={searchValue}
          handleClose={toggleAdvSearchVisible}
          setSearchFromAdvanced={(value) => setSearchValue(value)}
        />
      ) : (
        <div className='normal-search-row d-flex justify-content-between align-items-center px-3 pb-3'>
          <h2 className='h3 font-weight-bold search-title mb-0 w-100'>
            <TabIndexBtn handleClick={handleCloseSearch}>
              <FaRegWindowClose
                className='search-title__icon mr-4 p-1'
                title='Back to Document'
              />
            </TabIndexBtn>
            Search Results for:
            <div className='d-flex flex-row align-items-center mt-2 w-50'>
              <input
                className='form-control w-100'
                type='text'
                name='Keyword'
                id='Keyword'
                value={searchKeyword}
                onChange={handleInput}
                onKeyDown={handleInput}
                placeholder='Keyword'
              />
              <span className='ml-2'>
                <FaSearch
                  onMouseEnter={() => $('[data-toggle="tooltip"]').tooltip()}
                  data-toggle={searchValue.length < 1 ? 'tooltip' : ''}
                  title={
                    searchValue.length < 1
                      ? 'Please enter a search term.'
                      : 'Press enter to search.'
                  }
                  data-original-title={
                    searchValue.length < 1
                      ? 'Please enter a search term.'
                      : 'Press enter to search.'
                  }
                  className={`mx-2 search__click${
                    searchValue.length > 0 ? '' : ' disabled'
                  }`}
                />
              </span>
            </div>
          </h2>
          {!pageSearchLoading && !docSearchLoading && (
            <TabIndexBtn
              css='adv-search-icon'
              handleClick={toggleAdvSearchVisible}
            >
              <FaSearchengin />
            </TabIndexBtn>
          )}
        </div>
      )}
      {searchResults &&
      searchResults.length === 0 &&
      documentResults &&
      documentResults.length === 0 ? (
        <div className='col main-content-wrapper'>
          <p className='results-number my-4 d-flex justify-content-end w-100 font-weight-bold'>
            No results
          </p>
        </div>
      ) : (
        <React.Fragment>
          <div className='row order-row d-flex justify-content-between mb-4 p-3 mx-0'>
            <div className='results-wrapper'>
              {/* <div className='search-tabs'>
                <span>I'm searching for:</span>
                <TabIndexBtn handleClick={() => setSelectedTab(1)}>
                  <span
                    className={`search-tabs__option${
                      selectedTab === 1 ? ' active' : ''
                    }`}
                  >
                    Regulation Title
                  </span>
                </TabIndexBtn>
                <TabIndexBtn handleClick={() => setSelectedTab(2)}>
                  <span
                    className={`search-tabs__option${
                      selectedTab === 2 ? ' active' : ''
                    }`}
                  >
                    Regulation Content
                  </span>
                </TabIndexBtn>
              </div> */}
              {displayResults ? (
                <p className='results-number m-0'>
                  {selectedTab === 1
                    ? docSearchLoading
                      ? 'Searching...'
                      : `${displayResults.length} Document${
                          displayResults.length === 1 ? '' : 's'
                        } found`
                    : searchResults
                    ? pageSearchLoading
                      ? 'Searching...'
                      : `${searchResults.length} result${
                          searchResults.length === 1 ? '' : 's'
                        } from ${displayResults.length} Document${
                          displayResults.length === 1 ? '' : 's'
                        }`
                    : 'Loading...'}
                </p>
              ) : null}
            </div>
          </div>
          {!displayResults ||
          // (selectedTab === 1 && docSearchLoading) ||
          (selectedTab === 2 && pageSearchLoading) ? (
            <div className='inner-load'>
              <Loader text='Searching 50,000 pages...' />
            </div>
          ) : (
            <div className='results-accordion-wrapper'>
              <div className='d-flex align-items-center justify-content-start m-4'>
                <input
                  type='checkbox'
                  id='sub-search'
                  className='mt-1'
                  checked={onlyShowTitles}
                  onChange={() => setOnlyShowTitles((value) => !value)}
                />
                <label
                  htmlFor='sub-search'
                  style={{ cursor: 'pointer' }}
                  className='mb-0 ml-2'
                >
                  Display only documents with titles containing "
                  <u>{searchKeyword}</u>".
                </label>
              </div>
              <div className='row result-columns'>
                {orderedDocs &&
                  orderedDocs.length > 0 &&
                  DocSortColumns(selectedTab === 1).map((col, i) => {
                    return (
                      <div
                        className={col.CSS}
                        key={i}
                        data-toggle={isMobile && 'tooltip'}
                        data-original-title={col.TOOLTIP}
                      >
                        <p
                          className='sort-button'
                          onClick={() => handleSort(col.VALUE)}
                        >
                          {/* on larger screens, show text */}
                          {col.ICON} {!isMobile && col.DISPLAY}
                        </p>
                        {handleDisplayOrderBtn(col.VALUE)}
                      </div>
                    );
                  })}
              </div>
              <div className='accordion' id='documentsAccordion'>
                {/* foreach document found we want to have a Pagination logic */}
                {orderedDocs && orderedDocs.length > 0 ? (
                  orderedDocs.map((doc, i) => {
                    const docPages = getPagesFromDocument(doc.id);
                    const versionDate = doc.versionDate
                      ? doc.versionDate.toDateString().substr(4, 12)
                      : '-';
                    const ButtonItem = (
                      <div className='card-header' id={'heading-' + i}>
                        <h2 className='mb-0'>
                          {docPages.length > 0 ? (
                            <button
                              className='btn btn-link btn-block text-left collapsed tabIndex-btn'
                              type='button'
                              tabIndex={0}
                              data-toggle='collapse'
                              data-target={`#collapse-${doc.id}`}
                              aria-expanded='false'
                              aria-controls={`collapse-${doc.id}`}
                              onClickCapture={() =>
                                selectedTab === 1 ? null : handleToggleCard(doc)
                              }
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              {selectedTab === 2 && docPages?.length > 0 ? (
                                activeCard === doc.id ? (
                                  <BsArrowUp />
                                ) : (
                                  <BsArrowDown />
                                )
                              ) : null}
                              <div className='row mx-0'>
                                {/* Title */}
                                <div
                                  className={`col-${
                                    selectedTab === 1 ? '9' : '6'
                                  }`}
                                  data-toggle={isMobile && 'tooltip'}
                                  data-original-title={doc.title}
                                >
                                  <p
                                    className='title'
                                    dangerouslySetInnerHTML={{
                                      __html: replaceTitle(doc.title),
                                    }}
                                  />
                                  <label className='levels-label'>
                                    {defineTitle(doc)}
                                  </label>
                                </div>
                                {/* # of Results */}
                                <div
                                  className={
                                    selectedTab === 1
                                      ? 'd-none'
                                      : 'col-3 d-flex align-items-center justify-content-center'
                                  }
                                >
                                  <p className='text-center'>
                                    {docPages.length > 0
                                      ? docPages.length
                                      : '-'}
                                    {isMobile
                                      ? null
                                      : docPages.length > 0
                                      ? docPages.length > 1
                                        ? ' results'
                                        : ' result'
                                      : ''}
                                  </p>
                                </div>
                                {/* Date */}
                                <div
                                  className='col-3 d-flex align-items-center justify-content-center'
                                  data-toggle={isMobile && 'tooltip'}
                                  data-original-title={versionDate}
                                >
                                  <p className='text-center'>{versionDate}</p>
                                </div>
                              </div>
                            </button>
                          ) : (
                            <a
                              href={ROUTES.DOCUMENT(doc.slug)}
                              target='_blank'
                              rel='noreferrer'
                              className='btn btn-link btn-block text-left collapsed tabIndex-btn'
                            >
                              <div className='row mx-0'>
                                {/* Title */}
                                <div
                                  className={`col-${
                                    selectedTab === 1 ? '9' : '6'
                                  }`}
                                  data-toggle={isMobile && 'tooltip'}
                                  data-original-title={doc.title}
                                >
                                  <p
                                    className='title'
                                    dangerouslySetInnerHTML={{
                                      __html: replaceTitle(doc.title),
                                    }}
                                  />
                                  <label className='levels-label'>
                                    {defineTitle(doc)}
                                  </label>
                                </div>
                                {/* # of Results */}
                                <div
                                  className={
                                    selectedTab === 1
                                      ? 'd-none'
                                      : 'col-3 d-flex align-items-center justify-content-center'
                                  }
                                >
                                  <p className='text-center'>
                                    {docPages.length > 0
                                      ? docPages.length
                                      : '-'}
                                    {isMobile
                                      ? null
                                      : docPages.length > 0
                                      ? docPages.length > 1
                                        ? ' results'
                                        : ' result'
                                      : ''}
                                  </p>
                                </div>
                                {/* Date */}
                                <div
                                  className='col-3 d-flex align-items-center justify-content-center'
                                  data-toggle={isMobile && 'tooltip'}
                                  data-original-title={versionDate}
                                >
                                  <p className='text-center'>{versionDate}</p>
                                </div>
                              </div>
                            </a>
                          )}
                        </h2>
                      </div>
                    );
                    return (
                      <div key={doc.id} id={`card-${doc.id}`} className='card'>
                        {selectedTab === 1 ? (
                          <Link
                            to={ROUTES.DOCUMENT(doc.slug)}
                            target='_blank'
                            rel='noreferrer'
                          >
                            {ButtonItem}
                          </Link>
                        ) : (
                          ButtonItem
                        )}
                        {selectedTab === 1 ? null : (
                          <div
                            id={`collapse-${doc.id}`}
                            className='collapse'
                            aria-labelledby={'heading-' + i}
                            data-parent='#documentsAccordion'
                          >
                            <div className='card-body'>
                              <DocumentResults
                                pagesFoundInDocument={docPages}
                                handleOnTagSelected={handleSelectedTag}
                                isSearchPage={isSearchPage}
                                searchKeyword={searchValue}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className='d-flex flex-column ml-3'>
                    <h5>Your search did not return any results.</h5>
                    <h5 className='mt-4'>
                      Please change the search term and try again.
                    </h5>
                  </div>
                )}
              </div>
              {pageCount > 1 && (
                <div className='paginate-wrapper'>
                  <ReactPaginate
                    onPageChange={handlePaginationClick}
                    previousLabel={'previous'}
                    previousClassName={'paginate-previous'}
                    nextLabel={'next'}
                    nextClassName={'paginate-next'}
                    breakLabel={'...'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={10}
                    containerClassName={'pagination pagination-sm'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    activeClassName={'page-item active'}
                  />
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  pageSearchLoading: state.document.pageSearchLoading,
  docSearchLoading: state.document.docSearchLoading,
  page: state.document.currentPage,
  searchResults: state.document.searchResults,
  documentResults: state.document.documentResults,
  documents: state.client.documents,
});

const mapDispatchToProps = { setCurrentDocument, clearDocSearch, clearSearch };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(SearchResult);
